module.exports = __webpack_public_path__ + "static/img/cooperativePartner.0c9daa8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/cooperativePartner.png
// module id = R5Vq
// module chunks = 1